var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.url,"alt":"刷新重新加载..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }